import * as AvatarPrimitive from '@radix-ui/react-avatar'
import React from 'react'

import { cn } from '~/DesignSystem/lib/utils'

function Avatar({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Root>) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn('relative flex size-8 shrink-0 overflow-hidden rounded-full', className)}
      {...props}
    />
  )
}

export { Avatar }
